// extracted by mini-css-extract-plugin
export default {"snackbar__inner":"snackComponent_snackbar__inner__fK5+j","snackbar__closeIcon":"snackComponent_snackbar__closeIcon__Svbpf"};